import React, { useState } from "react";
import "./DonationEvent.css";

function HotelDonationEvent() {

  const [donation, setDonation] = useState({
    type: "",
    title: "",
    description: "",
    quantity: "",
    location: ""
  });

  const [event, setEvent] = useState({
    title: "",
    type: "",
    description: "",
    date: "",
    location: ""
  });

  const handleDonationChange = (e) => {
    setDonation({ ...donation, [e.target.name]: e.target.value });
  };

  const handleEventChange = (e) => {
    setEvent({ ...event, [e.target.name]: e.target.value });
  };

  const submitDonation = (e) => {
    e.preventDefault();
    alert("Donation submitted (backend will be added next)");
    console.log(donation);
  };

  const submitEvent = (e) => {
    e.preventDefault();
    alert("Event created (backend will be added next)");
    console.log(event);
  };

  return (
    <div className="donation-event-page">

       <h1 className="page-title">Contribute Beyond Food 💚</h1>

      <div className="card-container">

        {/* ---------------- DONATION CARD ---------------- */}
        <div className="card">
          <h2>🎁 Donate Items</h2>

          <form onSubmit={submitDonation}>
            <select name="type" onChange={handleDonationChange} required>
              <option value="">Select Donation Type</option>
              <option value="Clothes">Clothes</option>
              <option value="Stationery">Stationery</option>
              <option value="Toys">Toys</option>
              <option value="Other">Other</option>
            </select>

            <input name="title" placeholder="Item Title" onChange={handleDonationChange} required />
            <textarea name="description" placeholder="Item Description" onChange={handleDonationChange} />
            <input name="quantity" placeholder="Quantity" onChange={handleDonationChange} required />
            <input name="location" placeholder="Pickup Location" onChange={handleDonationChange} required />

            <button type="submit">Donate Items</button>
          </form>
        </div>

        {/* ---------------- EVENT CARD ---------------- */}
        <div className="card">
          <h2>🎉 Organize Event</h2>

          <form onSubmit={submitEvent}>
            <input name="title" placeholder="Event Title" onChange={handleEventChange} required />

            <select name="type" onChange={handleEventChange} required>
              <option value="">Select Event Type</option>
              <option value="Birthday Celebration">Birthday Celebration</option>
              <option value="Food Camp">Food Camp</option>
              <option value="Education Camp">Education Camp</option>
              <option value="Festival Event">Festival Event</option>
            </select>

            <textarea name="description" placeholder="Event Description" onChange={handleEventChange} />
            <input type="date" name="date" onChange={handleEventChange} required />
            <input name="location" placeholder="Event Location" onChange={handleEventChange} required />

            <button type="submit">Create Event</button>
          </form>
        </div>

      </div>
    </div>
  );
}

export default HotelDonationEvent;
